import Companies from './companiesv2.json';

const initialState = {
  companies: Companies.companies,
  selection: [],
  searchString: "",
  showSearch: true
}
initialState.selection = initialState.companies.map(company => Object.assign({}, company));


export default function(state = initialState, action) {
  if(action.type === "SHOW_SEARCH") {
    if(action.showSearch) {
      return {
        ...state,
        showSearch: action.showSearch,
        selection: state.companies.map(company => Object.assign({}, company)),
        searchString: "",
      };
    } else {
      return {
        ...state,
        showSearch: action.showSearch,
        selection: [],
        searchString: ""
      };
    }
  }
  if(action.type === "SEARCH_CHANGED") {

    var searchString = action.searchString;
    var searchStrings = searchString.split(" ");
    //var that = this;

    var compose = (fns) => x => fns.reduceRight((acc, curr) => acc || curr(x), false)

    var conditions = searchStrings.map(function(string) {
      if(string === "") {
        return function(company) { return false; }
      }
      if(string.startsWith("tag:")) {
        return function(company) {
          return company.tags ? company.tags.includes(string.split(":")[1]): false;
        };
      } else {
        return function(company){
          return company.name ? company.name.toLowerCase().includes(string.toLowerCase()) : false;
        };
      }
    });

    return {
      ...state,
      searchString: searchString,
      selection: state.companies.filter(compose(conditions)).map(company => Object.assign({}, company))
    }
  }
  return state;
}
